import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'select2/dist/css/select2.min.css';
import 'select2';
import 'datatables.net-dt';
import 'datatables.net-responsive-dt';
import 'datatables.net-buttons-dt';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import './sales_page.css';
import QRCode from 'qrcode';
import '@fortawesome/fontawesome-free/css/all.min.css';


const Tabs = {
  CREATE: 'create',
  INVOICES: 'invoices',
  LOYALTY: 'loyalty',
  REFERRAL_HISTORY: 'referral_history',
  PROMO_REPORT: 'promo_report',
};

const SalesPage = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [businessId, setBusinessId] = useState(null);
  const [businessLogo, setBusinessLogo] = useState(null);
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(Tabs.CREATE);
  const [businessSettings, setBusinessSettings] = useState(null);
  const [availableLoyaltyPoints, setAvailableLoyaltyPoints] = useState(null);
  const [checkingLoyalty, setCheckingLoyalty] = useState(false);
  const [showQRPopup, setShowQRPopup] = useState(false);
  const [discountCode, setDiscountCode] = useState('');
  const [discountApplied, setDiscountApplied] = useState(false);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [usingLoyalty, setUsingLoyalty] = useState(false);
  const [showShortcutsGuide, setShowShortcutsGuide] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  
  // Get logged-in user branch from sessionStorage
  const loggedInBranchId = useRef(null);
  const loggedInUserId = useRef(null);
  
  // DataTable instances - store them in refs
  const invoicesDataTableRef = useRef(null);
  const promoDataTableRef = useRef(null);
  const invoicesTableRef = useRef(null);
  const promoTableRef = useRef(null);

  
  const [referralHistory, setReferralHistory] = useState([]);
  const [referralAnalytics, setReferralAnalytics] = useState({ total_referrals: 0, successful_referrals: 0, promo_usage_count: 0 });
  const [referralSearchPhone, setReferralSearchPhone] = useState('');
  const [referralLoading, setReferralLoading] = useState(false);
  const [referralError, setReferralError] = useState(null);
  
  // Loyalty checker state
  const [loyaltyState, setLoyaltyState] = useState({
    searchTerm: '',
    searchType: 'phone',
    loyaltySummary: null,
  });

  // Generate unique invoice number with current date
  const generateInvoiceNumber = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
    return `INV-${year}${month}${day}-${hours}${minutes}${seconds}-${random}`;
  };

  // Tab 1: Create Record State
  const [createRecordState, setCreateRecordState] = useState({
    isSubmitting: false,
    formData: {
      invoice_number: generateInvoiceNumber(),
      customer_name: '',
      customer_number: '',
      date: new Date().toISOString().slice(0, 19).replace('T', ' '),
      cashier: '',
      details: [{ item_name: '', quantity: 1, price: 0, total: 0 }],
      tax_amount: 0,
      discount_amount: 0,
      subtotal_amount: 0,
      total_after_tax: 0,
      paid_amount: 0,
      remaining_amount: 0,
      loyalty_points_used: 0,
    },
    lastResponse: null,
    qrCodeUrl: null,
  });

  // Tab 2: View Invoices State
  const [invoicesState, setInvoicesState] = useState({
    isLoading: false,
    data: [],
    totalRecords: 0,
    filters: { start_date: '', end_date: '', search: '' },
  });

  // Tab 5: Promo Report State
  const [promoReportState, setPromoReportState] = useState({
    isLoading: false,
    data: [],
    total: 0,
    filters: { search: '', status: 'all', fromDate: '', toDate: '' },
  });

  // ======================= AUTH & INIT =======================
  useEffect(() => {
    const token = sessionStorage.getItem('token');
    const storedUserData = sessionStorage.getItem('userData');
    const storedBranchId = sessionStorage.getItem('branch_id');
    const storedUserId = sessionStorage.getItem('user_id');

    if (!token || !storedUserData) {
      Swal.fire({
        icon: 'warning',
        title: 'Access Denied',
        text: 'Please login to access this page',
        confirmButtonText: 'Login',
      }).then(() => navigate('/login'));
      return;
    }

    try {
      const user = JSON.parse(storedUserData);
      setUserData(user);
      if (user.businesslogo) setBusinessLogo(user.businesslogo);
      
      if (!user.businessId) {
        Swal.fire({ icon: 'error', title: 'Invalid Access', text: 'Business ID not found.' })
          .then(() => navigate('/'));
        return;
      }
      
      setBusinessId(user.businessId);
      loggedInBranchId.current = storedBranchId || user.branch_id;
      loggedInUserId.current = storedUserId || user.id;
      
      fetchBusinessSettings(user.businessId);
      fetchBranches(user.businessId);
      setLoading(false);
    } catch (error) {
      console.error('Error parsing user data:', error);
      navigate('/login');
    }
  }, [navigate]);

  const fetchBranches = async (businessIdValue) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_RECEIPT_BACK_END_URL}/fetch-Branches/${businessIdValue || businessId}`, {
        method: 'GET',
        headers: { 'Authorization': `Bearer ${sessionStorage.getItem('token')}` }
      });
      if (response.ok) {
        const data = await response.json();
        const branchData = Array.isArray(data) ? data : data.branchData || [];
        setBranches(branchData);
      }
    } catch (error) {
      console.error('Error fetching branches:', error);
    }
  };

  const fetchBusinessSettings = async (businessIdValue) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_RECEIPT_BACK_END_URL}/business/${businessIdValue || businessId}`, {
        method: 'GET',
        headers: { 'Authorization': `Bearer ${sessionStorage.getItem('token')}` }
      });
      if (response.ok) {
        const data = await response.json();
        const businessData = Array.isArray(data) ? data[0] : data;
        setBusinessSettings(businessData);
        if (businessData.logo) setBusinessLogo(businessData.logo);
      }
    } catch (error) {
      console.error('Error fetching business settings:', error);
    }
  };

  // ======================= INITIALIZE DATATABLES =======================
  const initInvoicesDataTable = useCallback(() => {
    if (!invoicesTableRef.current || !businessId) return;
    
    setTimeout(() => {
      if (!invoicesTableRef.current) return;
      
      try {
        
        const table = $(invoicesTableRef.current).DataTable({
          serverSide: true,
          processing: true,
          destroy: true,
          // IMPORTANT: Set default order to invoice_date DESC
          order: [[5, 'desc']], // 5 is the index of the 'Date' column (0-based index)
          ajax: {
            url: `${process.env.REACT_APP_RECEIPT_BACK_END_URL}/api/datatable/invoices/${businessId}`,
            type: 'GET',
            headers: {
              'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            },
            data: function(d) {
              // If no order is specified by DataTables, use our default
              if (!d.order || d.order.length === 0) {
                d.order = [{ column: 5, dir: 'desc' }];
              }
              return {
                draw: d.draw,
                start: d.start,
                length: d.length,
                search: d.search.value,
                order: d.order,
                columns: d.columns,
                branchId: loggedInBranchId.current || '',
                fromDate: invoicesState.filters.start_date || '',
                toDate: invoicesState.filters.end_date || ''
              };
            },
            error: function(xhr, error, thrown) {
              console.error('DataTable AJAX error:', error);
              console.error('Response:', xhr.responseText);
            }
          },
          pageLength: 10,
          lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
          dom: '<"dt-top-controls"<"dt-buttons"B><"dt-search"f>>rt<"dt-bottom-controls"<"dt-length"l><"dt-pagination"p>>',
          buttons: [
            { extend: 'copy', text: '<i class="fas fa-copy"></i> Copy', className: 'dt-button-custom' },
            { extend: 'csv', text: '<i class="fas fa-file-csv"></i> CSV', className: 'dt-button-custom' },
            { extend: 'excel', text: '<i class="fas fa-file-excel"></i> Excel', className: 'dt-button-custom' },
            { extend: 'pdf', text: '<i class="fas fa-file-pdf"></i> PDF', className: 'dt-button-custom', orientation: 'landscape', pageSize: 'A4' },
            { extend: 'print', text: '<i class="fas fa-print"></i> Print', className: 'dt-button-custom' },
          ],
          columns: [
            { data: 'invoice_number', title: 'Invoice #' },
            { data: 'customer_name', title: 'Customer Name' },
            { data: 'customer_cell', title: 'Customer Number' },
            { data: 'branch_name', title: 'Branch' },
            { data: 'total_after_tax', title: 'Total', render: (data) => parseFloat(data || 0).toFixed(2) },
            { data: 'invoice_date', title: 'Date' },
            { 
              data: null, 
              title: 'Actions',
              orderable: false,
              searchable: false,
              render: function(data, type, row) {
                const encodedData = encodeURIComponent(JSON.stringify({
                  unique_code: row.unique_code,
                  invoice_number: row.invoice_number,
                  customer_name: row.customer_name,
                  total_after_tax: row.total_after_tax
                }));
                return `
                  <button class="btn-view-invoice" onclick="window.open('${process.env.REACT_APP_RECEIPT_FRONT_END}/${row.unique_code}', '_blank')">
                    <i class="fas fa-eye"></i>
                  </button>
                  <button class="btn-print-qr" onclick="window.handleQRClick('${encodedData}')">
                    <i class="fas fa-qrcode"></i>
                  </button>
                `;
              }
            }
          ],
          language: {
            processing: '<div class="data-table-spinner"><div class="spinner"></div></div>',
            searchPlaceholder: 'Search invoices...',
            lengthMenu: 'Show _MENU_ entries',
            info: 'Showing _START_ to _END_ of _TOTAL_ entries',
            infoEmpty: 'Showing 0 to 0 of 0 entries',
            infoFiltered: '(filtered from _MAX_ total entries)',
            paginate: { 
              first: '<i class="fas fa-angle-double-left"></i>', 
              last: '<i class="fas fa-angle-double-right"></i>',
              previous: '<i class="fas fa-angle-left"></i>', 
              next: '<i class="fas fa-angle-right"></i>'
            }
          }
        });
        
        invoicesDataTableRef.current = table;
      } catch (error) {
        console.error('Error initializing invoices DataTable:', error);
      }
    }, 100);
  }, [businessId, invoicesState.filters.start_date, invoicesState.filters.end_date]);

  const initPromoDataTable = useCallback(() => {
    if (!promoTableRef.current || !businessId) return;
    
    setTimeout(() => {
      if (!promoTableRef.current) return;
      
      try {
        // if ($.fn.DataTable.isDataTable(promoTableRef.current)) {
        //   $(promoTableRef.current).DataTable().destroy(true);
        // }
        
        const table = $(promoTableRef.current).DataTable({
          serverSide: true,
          processing: true,
          destroy: true,
          ajax: {
            url: `${process.env.REACT_APP_RECEIPT_BACK_END_URL}/api/datatable/promos/${businessId}`,
            type: 'GET',
            headers: { 'Authorization': `Bearer ${sessionStorage.getItem('token')}` },
            data: function(d) {
              return {
                draw: d.draw,
                start: d.start,
                length: d.length,
                search: d.search.value,
                order: d.order,
                columns: d.columns,
                branchId: loggedInBranchId.current || '',
                status: promoReportState.filters.status,
                fromDate: promoReportState.filters.fromDate,
                toDate: promoReportState.filters.toDate
              };
            },
            error: function(xhr, error, thrown) {
              console.error('Promo DataTable AJAX error:', error);
            }
          },
          pageLength: 10,
          lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]],
          dom: '<"dt-top-controls"<"dt-buttons"B><"dt-search"f>>rt<"dt-bottom-controls"<"dt-length"l><"dt-pagination"p>>',
          buttons: [
            { extend: 'copy', text: '<i class="fas fa-copy"></i> Copy', className: 'dt-button-custom' },
            { extend: 'csv', text: '<i class="fas fa-file-csv"></i> CSV', className: 'dt-button-custom' },
            { extend: 'excel', text: '<i class="fas fa-file-excel"></i> Excel', className: 'dt-button-custom' },
            { extend: 'pdf', text: '<i class="fas fa-file-pdf"></i> PDF', className: 'dt-button-custom', orientation: 'landscape', pageSize: 'A4' },
            { extend: 'print', text: '<i class="fas fa-print"></i> Print', className: 'dt-button-custom' }
            
          ],
          columns: [
            { data: 'promo_code', title: 'Promo Code', render: (data) => `<code>${escapeHtml(data) || '-'}</code>` },
            { data: 'ref_sender', title: 'Sender', render: (data) => escapeHtml(data) || '-' },
            { data: 'receiver_name', title: 'Receiver Name', render: (data) => escapeHtml(data) || '-' },
            { data: 'loyalty_points', title: 'Points', render: (data) => data || 0 },
            { data: 'branch_sent_from', title: 'Branch Sent', render: (data) => escapeHtml(data) || '-' },
            { data: 'branch_used_in', title: 'Branch Used', render: (data) => escapeHtml(data) || '-' },
            { 
              data: null, title: 'Status',
              render: (data) => {
                if (data.is_used === 1) return '<span class="status-badge used">Used</span>';
                return '<span class="status-badge pending">Pending</span>';
              }
            },
            { data: 'used_at', title: 'Used At', render: (data) => data ? new Date(data).toLocaleDateString() : '-' },
            { data: 'created_at', title: 'Created At', render: (data) => data ? new Date(data).toLocaleDateString() : '-' },
            { 
              data: 'created_at', title: 'Expired', 
              render: (data) => {
                if (!data) return '-';
                const createdDate = new Date(data);
                const oneWeekAgo = new Date();
                oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
                const isExpired = createdDate < oneWeekAgo;
                return isExpired ? '<span class="status-expired">Expired</span>' : '<span class="status-valid">Valid</span>';
              }
            }
          ],
          order: [[8, 'desc']],
          language: {
            processing: '<div class="data-table-spinner"><div class="spinner"></div></div>',
            searchPlaceholder: 'Search promo codes...',
            lengthMenu: 'Show _MENU_ entries',
            info: 'Showing _START_ to _END_ of _TOTAL_ entries',
            infoEmpty: 'Showing 0 to 0 of 0 entries',
            infoFiltered: '(filtered from _MAX_ total entries)',
            paginate: { 
              first: '<i class="fas fa-angle-double-left"></i>', 
              last: '<i class="fas fa-angle-double-right"></i>',
              previous: '<i class="fas fa-angle-left"></i>', 
              next: '<i class="fas fa-angle-right"></i>'
            }
          }
        });
        
        promoDataTableRef.current = table;
      } catch (error) {
        console.error('Error initializing promo DataTable:', error);
      }
    }, 100);
  }, [businessId, promoReportState.filters.status, promoReportState.filters.fromDate, promoReportState.filters.toDate]);

  // ======================= TAB CHANGE HANDLER =======================
  const handleTabChange = async (tab) => {
    
    // Reset create form when leaving create tab
    if (activeTab === Tabs.CREATE && tab !== Tabs.CREATE) {
      resetCreateForm();
    }
    
    setActiveTab(tab);
    setIsDrawerOpen(false);
    
    // Initialize new tab's DataTable after a delay
    if (tab === Tabs.INVOICES) {
      setTimeout(() => initInvoicesDataTable(), 500);
    }
    if (tab === Tabs.PROMO_REPORT) {
      setTimeout(() => initPromoDataTable(), 500);
    }
  };

  // ======================= TAB 1: CREATE RECORD =======================
  const resetCreateForm = () => {
    setCreateRecordState({
      isSubmitting: false,
      formData: {
        invoice_number: generateInvoiceNumber(),
        customer_name: '',
        customer_number: '',
        date: new Date().toISOString().slice(0, 19).replace('T', ' '),
        cashier: userData?.name || '',
        details: [{ item_name: '', quantity: 1, price: 0, total: 0 }],
        tax_amount: 0,
        discount_amount: 0,
        subtotal_amount: 0,
        total_after_tax: 0,
        paid_amount: 0,
        remaining_amount: 0,
        loyalty_points_used: 0,
      },
      lastResponse: null,
      qrCodeUrl: null,
    });
    setAvailableLoyaltyPoints(null);
    setDiscountCode('');
    setDiscountApplied(false);
    setDiscountPercentage(0);
    setUsingLoyalty(false);
  };

  const handleCreateRecordInputChange = (e) => {
    const { name, value } = e.target;
    setCreateRecordState(prev => ({
      ...prev,
      formData: { ...prev.formData, [name]: value }
    }));
  };

  const handleDetailRowChange = (index, field, value) => {
    const newDetails = [...createRecordState.formData.details];
    newDetails[index][field] = value;
    if (field === 'quantity' || field === 'price') {
      newDetails[index].total = (newDetails[index].quantity || 0) * (newDetails[index].price || 0);
    }
    
    const subtotal = newDetails.reduce((sum, item) => sum + (item.total || 0), 0);
    const taxAmount = (subtotal * (createRecordState.formData.tax_amount || 0)) / 100;
    const discount = usingLoyalty ? 0 : createRecordState.formData.discount_amount;
    const totalAfterTax = subtotal + taxAmount - discount - (createRecordState.formData.loyalty_points_used || 0);
    const remainingAmount = totalAfterTax - (createRecordState.formData.paid_amount || 0);
    
    setCreateRecordState(prev => ({
      ...prev,
      formData: {
        ...prev.formData,
        details: newDetails,
        subtotal_amount: subtotal,
        total_after_tax: totalAfterTax > 0 ? totalAfterTax : 0,
        remaining_amount: remainingAmount > 0 ? remainingAmount : 0
      }
    }));
  };

  const isLastRowEmpty = () => {
    const details = createRecordState.formData.details;
    if (details.length === 0) return true;
    const lastRow = details[details.length - 1];
    return !lastRow.item_name || lastRow.item_name.trim() === '' || lastRow.price === 0;
  };

  const addDetailRow = () => {
    if (isLastRowEmpty()) {
      Swal.fire({
        icon: 'warning',
        title: 'Cannot Add Row',
        text: 'Please fill the current row before adding a new one.',
        timer: 1500,
        showConfirmButton: false
      });
      return;
    }
    
    setCreateRecordState(prev => ({
      ...prev,
      formData: {
        ...prev.formData,
        details: [...prev.formData.details, { item_name: '', quantity: 1, price: 0, total: 0 }]
      }
    }));
  };

  const removeDetailRow = (index) => {
    const newDetails = createRecordState.formData.details.filter((_, i) => i !== index);
    const subtotal = newDetails.reduce((sum, item) => sum + (item.total || 0), 0);
    const taxAmount = (subtotal * (createRecordState.formData.tax_amount || 0)) / 100;
    const discount = usingLoyalty ? 0 : createRecordState.formData.discount_amount;
    const totalAfterTax = subtotal + taxAmount - discount - (createRecordState.formData.loyalty_points_used || 0);
    const remainingAmount = totalAfterTax - (createRecordState.formData.paid_amount || 0);
    
    setCreateRecordState(prev => ({
      ...prev,
      formData: {
        ...prev.formData,
        details: newDetails,
        subtotal_amount: subtotal,
        total_after_tax: totalAfterTax > 0 ? totalAfterTax : 0,
        remaining_amount: remainingAmount > 0 ? remainingAmount : 0
      }
    }));
  };

  const removeLastEmptyRow = () => {
    const details = createRecordState.formData.details;
    if (details.length <= 1) {
      Swal.fire({
        icon: 'warning',
        title: 'Cannot Remove',
        text: 'At least one row is required.',
        timer: 1500,
        showConfirmButton: false
      });
      return;
    }
    
    const lastRow = details[details.length - 1];
    if (!lastRow.item_name || lastRow.item_name.trim() === '' || lastRow.price === 0) {
      removeDetailRow(details.length - 1);
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Cannot Remove',
        text: 'Only empty rows can be removed using this shortcut.',
        timer: 1500,
        showConfirmButton: false
      });
    }
  };

  const handleTaxChange = (e) => {
    const tax = parseFloat(e.target.value) || 0;
    const subtotal = createRecordState.formData.subtotal_amount;
    const taxAmount = (subtotal * tax) / 100;
    const discount = usingLoyalty ? 0 : createRecordState.formData.discount_amount;
    const totalAfterTax = subtotal + taxAmount - discount - (createRecordState.formData.loyalty_points_used || 0);
    const remainingAmount = totalAfterTax - (createRecordState.formData.paid_amount || 0);
    
    setCreateRecordState(prev => ({
      ...prev,
      formData: { 
        ...prev.formData, 
        tax_amount: tax, 
        total_after_tax: totalAfterTax > 0 ? totalAfterTax : 0,
        remaining_amount: remainingAmount > 0 ? remainingAmount : 0
      }
    }));
  };

  const formatPhoneForBackend = (phone) => {
    if (!phone) return phone;
    let cleaned = phone.replace(/\D/g, '');
    if (cleaned.startsWith('0')) cleaned = cleaned.substring(1);
    if (cleaned.startsWith('92')) cleaned = cleaned.substring(2);
    return '+92' + cleaned;
  };

  const checkAvailableLoyaltyPoints = async (customerNumber) => {
    if (!customerNumber || customerNumber.length < 10) {
      setAvailableLoyaltyPoints(null);
      return;
    }
    setCheckingLoyalty(true);
    const formattedPhone = formatPhoneForBackend(customerNumber);
    
    try {
      const response = await fetch(`${process.env.REACT_APP_RECEIPT_BACK_END_URL}/api/loyalty/available?business_id=${businessId}&phone_number=${encodeURIComponent(formattedPhone)}`, {
        headers: { 'Authorization': `Bearer ${sessionStorage.getItem('token')}` }
      });
      const data = await response.json();
      if (data.success) {
        setAvailableLoyaltyPoints(data);
      } else {
        setAvailableLoyaltyPoints(null);
      }
    } catch (error) {
      console.error('Error checking loyalty points:', error);
      setAvailableLoyaltyPoints(null);
    } finally {
      setCheckingLoyalty(false);
    }
  };
  
  const handleCustomerNumberChange = (e) => {
    const value = e.target.value;
    let displayValue = value;
    if (displayValue.startsWith('+92')) displayValue = displayValue.substring(3);
    setCreateRecordState(prev => ({
      ...prev,
      formData: { ...prev.formData, customer_number: displayValue }
    }));
    checkAvailableLoyaltyPoints(displayValue);
    if (usingLoyalty) {
      setUsingLoyalty(false);
      setCreateRecordState(prev => ({
        ...prev,
        formData: { ...prev.formData, loyalty_points_used: 0, discount_amount: 0 }
      }));
    }
  };

  const handleLoyaltyPointsChange = async (e) => {
    const points = parseFloat(e.target.value) || 0;
    const customerNumber = createRecordState.formData.customer_number;
    
    if (!customerNumber) {
      Swal.fire({ icon: 'warning', title: 'Warning', text: 'Please enter customer number first!' });
      return;
    }
    
    if (availableLoyaltyPoints && points > availableLoyaltyPoints.available_points) {
      Swal.fire({ icon: 'warning', title: 'Insufficient Points', text: `Customer has only ${availableLoyaltyPoints.available_points} points available.` });
      return;
    }
    
    if (points > 0) {
      setUsingLoyalty(true);
      setDiscountCode('');
      setDiscountApplied(false);
      setDiscountPercentage(0);
      setCreateRecordState(prev => ({
        ...prev,
        formData: { ...prev.formData, discount_amount: 0 }
      }));
    } else {
      setUsingLoyalty(false);
    }
    
    const subtotal = createRecordState.formData.subtotal_amount;
    const taxAmount = (subtotal * (createRecordState.formData.tax_amount || 0)) / 100;
    const discount = usingLoyalty ? 0 : createRecordState.formData.discount_amount;
    const totalAfterTax = subtotal + taxAmount - discount - points;
    const remainingAmount = totalAfterTax - (createRecordState.formData.paid_amount || 0);
    
    setCreateRecordState(prev => ({
      ...prev,
      formData: { 
        ...prev.formData, 
        loyalty_points_used: points,
        total_after_tax: totalAfterTax > 0 ? totalAfterTax : 0,
        remaining_amount: remainingAmount > 0 ? remainingAmount : 0
      }
    }));
  };

  const isPromoExpired = (createdAt) => {
    if (!createdAt) return false;
    const createdDate = new Date(createdAt);
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    return createdDate < oneWeekAgo;
  };

  const handleDiscountCodeChange = async (e) => {
    const code = e.target.value.toUpperCase();
    setDiscountCode(code);
    
    if (!code || code.trim() === '') {
      // Reset all discount-related states
      setDiscountApplied(false);
      setDiscountPercentage(0);
      setUsingLoyalty(false);
      
      // IMPORTANT: Reset discount amount in form data
      const subtotal = createRecordState.formData.subtotal_amount;
      const taxAmount = (subtotal * (createRecordState.formData.tax_amount || 0)) / 100;
      const loyaltyPointsUsed = createRecordState.formData.loyalty_points_used || 0;
      const totalAfterTax = subtotal + taxAmount - 0 - loyaltyPointsUsed;
      const remainingAmount = totalAfterTax - (createRecordState.formData.paid_amount || 0);
      
      setCreateRecordState(prev => ({
        ...prev,
        formData: { 
          ...prev.formData, 
          discount_amount: 0,
          total_after_tax: totalAfterTax > 0 ? totalAfterTax : 0,
          remaining_amount: remainingAmount > 0 ? remainingAmount : 0
        }
      }));
      return;
    }
    
    if (usingLoyalty) {
      setUsingLoyalty(false);
      setCreateRecordState(prev => ({
        ...prev,
        formData: { ...prev.formData, loyalty_points_used: 0 }
      }));
    }
    
    // Get the customer phone number
    const customerNumber = createRecordState.formData.customer_number;
    
    if (!customerNumber || customerNumber.trim() === '') {
      Swal.fire({ 
        icon: 'warning', 
        title: 'Customer Number Required', 
        text: 'Please enter customer number before applying discount code' 
      });
      setDiscountCode('');
      setDiscountApplied(false);
      setDiscountPercentage(0);
      // Reset discount amount
      const subtotal = createRecordState.formData.subtotal_amount;
      const taxAmount = (subtotal * (createRecordState.formData.tax_amount || 0)) / 100;
      const loyaltyPointsUsed = createRecordState.formData.loyalty_points_used || 0;
      const totalAfterTax = subtotal + taxAmount - 0 - loyaltyPointsUsed;
      const remainingAmount = totalAfterTax - (createRecordState.formData.paid_amount || 0);
      
      setCreateRecordState(prev => ({
        ...prev,
        formData: { 
          ...prev.formData, 
          discount_amount: 0,
          total_after_tax: totalAfterTax > 0 ? totalAfterTax : 0,
          remaining_amount: remainingAmount > 0 ? remainingAmount : 0
        }
      }));
      return;
    }
    
    // Format phone number for backend
    const formattedPhone = formatPhoneForBackend(customerNumber);
    
    try {
      const response = await fetch(`${process.env.REACT_APP_RECEIPT_BACK_END_URL}/api/promo/status?business_id=${businessId}&promo_code=${encodeURIComponent(code)}&phone_number=${encodeURIComponent(formattedPhone)}&branch_id=${loggedInBranchId.current}`, {
        headers: { 'Authorization': `Bearer ${sessionStorage.getItem('token')}` }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.is_used === 1) {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Promo code already used' });
        setDiscountCode('');
        setDiscountApplied(false);
        setDiscountPercentage(0);
        // Reset discount amount
        const subtotal = createRecordState.formData.subtotal_amount;
        const taxAmount = (subtotal * (createRecordState.formData.tax_amount || 0)) / 100;
        const loyaltyPointsUsed = createRecordState.formData.loyalty_points_used || 0;
        const totalAfterTax = subtotal + taxAmount - 0 - loyaltyPointsUsed;
        const remainingAmount = totalAfterTax - (createRecordState.formData.paid_amount || 0);
        
        setCreateRecordState(prev => ({
          ...prev,
          formData: { 
            ...prev.formData, 
            discount_amount: 0,
            total_after_tax: totalAfterTax > 0 ? totalAfterTax : 0,
            remaining_amount: remainingAmount > 0 ? remainingAmount : 0
          }
        }));
        return;
      }
      
      if (data.created_at && isPromoExpired(data.created_at)) {
        Swal.fire({ 
          icon: 'error', 
          title: 'Expired Promo', 
          text: 'This promo code is expired (older than 1 week)' 
        });
        setDiscountCode('');
        setDiscountApplied(false);
        setDiscountPercentage(0);
        // Reset discount amount
        const subtotal = createRecordState.formData.subtotal_amount;
        const taxAmount = (subtotal * (createRecordState.formData.tax_amount || 0)) / 100;
        const loyaltyPointsUsed = createRecordState.formData.loyalty_points_used || 0;
        const totalAfterTax = subtotal + taxAmount - 0 - loyaltyPointsUsed;
        const remainingAmount = totalAfterTax - (createRecordState.formData.paid_amount || 0);
        
        setCreateRecordState(prev => ({
          ...prev,
          formData: { 
            ...prev.formData, 
            discount_amount: 0,
            total_after_tax: totalAfterTax > 0 ? totalAfterTax : 0,
            remaining_amount: remainingAmount > 0 ? remainingAmount : 0
          }
        }));
        return;
      }
      
      if (data.is_used === 0 || data.is_used === false) {
        const branchResponse = await fetch(`${process.env.REACT_APP_RECEIPT_BACK_END_URL}/api/branch-discount/${loggedInBranchId.current}`, {
          headers: { 'Authorization': `Bearer ${sessionStorage.getItem('token')}` }
        });
        if (branchResponse.ok) {
          const branchData = await branchResponse.json();
          const discountPercent = branchData.discount_percentage || 0;
          setDiscountPercentage(discountPercent);
          setDiscountApplied(true);
          
          const subtotal = createRecordState.formData.subtotal_amount;
          const discountAmount = (subtotal * discountPercent) / 100;
          const taxAmount = (subtotal * (createRecordState.formData.tax_amount || 0)) / 100;
          const loyaltyPointsUsed = createRecordState.formData.loyalty_points_used || 0;
          const totalAfterTax = subtotal + taxAmount - discountAmount - loyaltyPointsUsed;
          const remainingAmount = totalAfterTax - (createRecordState.formData.paid_amount || 0);
          
          setCreateRecordState(prev => ({
            ...prev,
            formData: {
              ...prev.formData,
              discount_amount: discountAmount,
              total_after_tax: totalAfterTax > 0 ? totalAfterTax : 0,
              remaining_amount: remainingAmount > 0 ? remainingAmount : 0
            }
          }));
          
          Swal.fire({ icon: 'success', title: 'Discount Applied', text: `${discountPercent}% discount applied!`, timer: 1500, showConfirmButton: false });
        }
      }
    } catch (error) {
      console.error('Error validating promo code:', error);
      Swal.fire({ icon: 'error', title: 'Error', text: 'Invalid promo code or customer number' });
      setDiscountCode('');
      setDiscountApplied(false);
      setDiscountPercentage(0);
      // Reset discount amount
      const subtotal = createRecordState.formData.subtotal_amount;
      const taxAmount = (subtotal * (createRecordState.formData.tax_amount || 0)) / 100;
      const loyaltyPointsUsed = createRecordState.formData.loyalty_points_used || 0;
      const totalAfterTax = subtotal + taxAmount - 0 - loyaltyPointsUsed;
      const remainingAmount = totalAfterTax - (createRecordState.formData.paid_amount || 0);
      
      setCreateRecordState(prev => ({
        ...prev,
        formData: { 
          ...prev.formData, 
          discount_amount: 0,
          total_after_tax: totalAfterTax > 0 ? totalAfterTax : 0,
          remaining_amount: remainingAmount > 0 ? remainingAmount : 0
        }
      }));
    }
  };

  const validateCustomerNumber = () => {
    const customerNumber = createRecordState.formData.customer_number;
    if (!customerNumber || customerNumber.trim() === '') {
      Swal.fire({ 
        icon: 'warning', 
        title: 'Customer Number Required', 
        text: 'Please enter customer number first before applying discount code' 
      });
      return false;
    }
    if (customerNumber.length < 10) {
      Swal.fire({ 
        icon: 'warning', 
        title: 'Invalid Number', 
        text: 'Please enter a valid customer phone number' 
      });
      return false;
    }
    return true;
  };

  const handlePaidAmountChange = (e) => {
    const paid = parseFloat(e.target.value) || 0;
    const remaining = createRecordState.formData.total_after_tax - paid;
    
    setCreateRecordState(prev => ({
      ...prev,
      formData: {
        ...prev.formData,
        paid_amount: paid,
        remaining_amount: remaining > 0 ? remaining : 0
      }
    }));
  };

  const handleCreateRecordSubmit = async (e) => {
    e.preventDefault();
    
    if (!createRecordState.formData.customer_name || createRecordState.formData.customer_name.trim() === '') {
      Swal.fire({ icon: 'warning', title: 'Warning', text: 'Please enter customer name!' });
      return;
    }
    if (!createRecordState.formData.customer_number || createRecordState.formData.customer_number.trim() === '') {
      Swal.fire({ icon: 'warning', title: 'Warning', text: 'Please enter customer number!' });
      return;
    }
    
    const hasValidItems = createRecordState.formData.details.some(detail => 
      detail.item_name && detail.item_name.trim() !== '' && detail.price > 0
    );
    
    if (!hasValidItems) {
      Swal.fire({ icon: 'warning', title: 'Warning', text: 'Please add at least one valid item with name and price!' });
      return;
    }
    
    setCreateRecordState(prev => ({ ...prev, isSubmitting: true }));
    
    const formattedPhone = formatPhoneForBackend(createRecordState.formData.customer_number);
    
    const detailsObject = {};
    createRecordState.formData.details.forEach((detail, index) => {
      if (detail.item_name && detail.item_name.trim() !== '') {
        detailsObject[index] = {
          product_name: detail.item_name,
          qty: detail.quantity,
          unit_price: detail.price,
          total_price: detail.total,
          discount_amount: 0,
          discount_percentage: 0,
        };
      }
    });
    
    const payload = {
      userId: userData?.id,
      business_id: businessId,
      branch_id: parseInt(loggedInBranchId.current),
      invoice_number: createRecordState.formData.invoice_number,
      customer_name: createRecordState.formData.customer_name,
      customer_cell: formattedPhone,
      date: createRecordState.formData.date,
      cashier: createRecordState.formData.cashier || userData?.name,
      subtotal_amount: createRecordState.formData.subtotal_amount,
      discount: createRecordState.formData.discount_amount,
      discount_code_used: discountApplied ? discountCode : null,
      total_tax: (createRecordState.formData.subtotal_amount * (createRecordState.formData.tax_amount || 0)) / 100,
      total_after_tax: createRecordState.formData.total_after_tax,
      paid_amount: createRecordState.formData.paid_amount,
      remaining_amount: createRecordState.formData.remaining_amount,
      points_used: createRecordState.formData.loyalty_points_used || 0,
      detail: detailsObject
    };
    
    try {
      if (payload.points_used > 0) {
        const loyaltyResponse = await fetch(`${process.env.REACT_APP_RECEIPT_BACK_END_URL}/api/loyalty/use`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('token')}`
          },
          body: JSON.stringify({
            phone_number: formattedPhone,
            business_id: businessId,
            points_to_use: payload.points_used,
            branch_id: payload.branch_id
          })
        });
        
        if (!loyaltyResponse.ok) {
          const errorData = await loyaltyResponse.json();
          throw new Error(errorData.error || 'Failed to use loyalty points');
        }
      }
      
      if (discountApplied && discountCode) {
        const promoResponse = await fetch(`${process.env.REACT_APP_RECEIPT_BACK_END_URL}/api/promo/use`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('token')}`
          },
          body: JSON.stringify({
            phone_number: formattedPhone,
            promo_code: discountCode,
            business_id: businessId,
            branch_id: payload.branch_id
          })
        });
        
        if (!promoResponse.ok) {
          const errorData = await promoResponse.json();
          if (!errorData.error?.includes('already been used')) {
            console.warn('Promo code usage issue:', errorData);
          }
        }
      }
      
      const response = await fetch(`${process.env.REACT_APP_RECEIPT_BACK_END_URL}/insert-receipt`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionStorage.getItem('token')}`
        },
        body: JSON.stringify(payload)
      });
      
      const data = await response.json();
      
      if (response.ok) {
        const customerNameBackup = createRecordState.formData.customer_name;
        const customerNumberBackup = createRecordState.formData.customer_number;
        const receiptUrl = data.reciept_url;
        
        let qrData = null;
        if (receiptUrl) {
          try {
            qrData = await QRCode.toDataURL(receiptUrl);
          } catch (qrError) {
            console.error('QR generation error:', qrError);
            Swal.fire({ icon: 'warning', title: 'QR Generation Failed', text: 'Receipt created but QR code could not be generated.', timer: 2000, showConfirmButton: false });
          }
        }
        
        const newInvoiceNumber = generateInvoiceNumber();
        
        setCreateRecordState({
          isSubmitting: false,
          formData: {
            invoice_number: newInvoiceNumber,
            customer_name: '',
            customer_number: '',
            date: new Date().toISOString().slice(0, 19).replace('T', ' '),
            cashier: userData?.name || '',
            details: [{ item_name: '', quantity: 1, price: 0, total: 0 }],
            tax_amount: 0,
            discount_amount: 0,
            subtotal_amount: 0,
            total_after_tax: 0,
            paid_amount: 0,
            remaining_amount: 0,
            loyalty_points_used: 0,
          },
          lastResponse: { 
            reciept_url: receiptUrl,
            customer_name: customerNameBackup,
            customer_number: customerNumberBackup
          },
          qrCodeUrl: qrData,
        });
        
        setAvailableLoyaltyPoints(null);
        setDiscountCode('');
        setDiscountApplied(false);
        setDiscountPercentage(0);
        setUsingLoyalty(false);
        
        if (qrData) setShowQRPopup(true);
        
        // Refresh DataTables if they exist
        if (invoicesDataTableRef.current) {
          invoicesDataTableRef.current.ajax.reload(null, false);
        }
        if (promoDataTableRef.current) {
          promoDataTableRef.current.ajax.reload(null, false);
        }
        
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: `Receipt created successfully! Invoice #: ${payload.invoice_number}`,
          timer: 3000,
          showConfirmButton: false
        });
      } else {
        throw new Error(data.message || 'Failed to create receipt');
      }
    } catch (error) {
      console.error('Error creating receipt:', error);
      Swal.fire({ icon: 'error', title: 'Error', text: error.message || 'Failed to create receipt. Please try again.' });
      setCreateRecordState(prev => ({ ...prev, isSubmitting: false }));
    }
  };
  
  const printQR = () => {
    const customerName = createRecordState.lastResponse?.customer_name || 'N/A';
    const customerNumber = createRecordState.lastResponse?.customer_number || 'N/A';
    
    const printWindow = window.open('', '_blank', 'width=600,height=600');
    if (!printWindow) {
      Swal.fire({ icon: 'error', title: 'Popup blocked', text: 'Please allow popups to print QR.' });
      return;
    }

    const styles = `
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif; padding: 30px 20px; background: #f5f7fb; }
        .qr-print-container { max-width: 400px; margin: 0 auto; background: white; border-radius: 20px; padding: 30px 25px; text-align: center; box-shadow: 0 20px 35px -10px rgba(0,0,0,0.1); }
        .business-logo { max-width: 80px; margin-bottom: 20px; }
        .qr-code { margin: 25px 0; }
        .qr-code img { max-width: 160px; border-radius: 12px; }
        .receipt-url { background: #f8f9fa; padding: 10px; border-radius: 10px; word-break: break-all; font-size: 11px; margin: 15px 0; font-family: monospace; }
        .customer-info { text-align: left; background: #f8f9fa; padding: 15px; border-radius: 12px; margin: 15px 0; }
        .customer-info p { margin: 6px 0; font-size: 13px; }
        .customer-info strong { color: #1f2937; }
        @media print { body { background: white; padding: 0; } .qr-print-container { box-shadow: none; padding: 20px; } }
      </style>
    `;

    const htmlContent = `
      <html>
      <head><meta charset="UTF-8"><title>QR Code</title>${styles}</head>
      <body>
        <div class="qr-print-container">
          ${businessLogo ? `<img src="${process.env.REACT_APP_RECEIPT_FRONT_END}/${businessLogo}" class="business-logo" onerror="this.style.display='none'" />` : ''}
          <div class="qr-code">${createRecordState.qrCodeUrl ? `<img src="${createRecordState.qrCodeUrl}" />` : '<p>QR code not available</p>'}</div>
          <div class="receipt-url"><strong>Receipt URL:</strong><br/>${createRecordState.lastResponse?.reciept_url || ''}</div>
          <div class="customer-info">
            <p><strong>Customer:</strong> ${escapeHtml(customerName)}</p>
            <p><strong>Phone:</strong> ${escapeHtml(customerNumber)}</p>
          </div>
        </div>
        <script>
          window.onload = function() { 
            setTimeout(function() { window.print(); }, 500);
            setTimeout(function() { window.close(); }, 2000);
          }
        <\/script>
      </body>
      </html>
    `;
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

  const generateInvoiceQR = async (invoice) => {
    const invoiceUrl = `${process.env.REACT_APP_RECEIPT_FRONT_END}/${invoice.unique_code}`;
    try {
      const qrDataUrl = await QRCode.toDataURL(invoiceUrl);
      const printWindow = window.open('', '_blank', 'width=500,height=550');
      if (printWindow) {
        const styles = `
          <style>
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body { font-family: 'Inter', sans-serif; display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #f5f7fb; }
            .container { text-align: center; background: white; padding: 30px; border-radius: 20px; box-shadow: 0 20px 35px -10px rgba(0,0,0,0.1); max-width: 400px; }
            .qr-code { margin: 20px 0; }
            .qr-code img { max-width: 180px; border-radius: 12px; }
            .info { margin-top: 20px; text-align: left; background: #f8f9fa; padding: 15px; border-radius: 12px; }
            .info p { margin: 8px 0; font-size: 14px; }
            .info strong { color: #1f2937; }
            button { margin-top: 20px; padding: 10px 20px; background: #4361ee; color: white; border: none; border-radius: 10px; cursor: pointer; font-size: 14px; }
          </style>
        `;
        printWindow.document.write(`
          <html><head><title>Invoice QR Code</title>${styles}</head>
          <body>
            <div class="container">
              ${businessLogo ? `<img src="${process.env.REACT_APP_RECEIPT_FRONT_END}/${businessLogo}" style="max-width:70px; margin-bottom:15px;" onerror="this.style.display='none'" />` : ''}
              <h3><i class="fas fa-qrcode"></i> Invoice QR Code</h3>
              <div class="qr-code"><img src="${qrDataUrl}" /></div>
              <div class="info">
                <p><strong>Invoice #:</strong> ${escapeHtml(invoice.invoice_number)}</p>
                <p><strong>Customer:</strong> ${escapeHtml(invoice.customer_name)}</p>
                <p><strong>Total:</strong> $${parseFloat(invoice.total_after_tax || 0).toFixed(2)}</p>
              </div>
              <button onclick="window.print()"><i class="fas fa-print"></i> Print</button>
            </div>
            <script>
              setTimeout(function() { window.print(); }, 500);
            <\/script>
          </body></html>
        `);
        printWindow.document.close();
      }
    } catch (error) {
      console.error('QR generation error:', error);
      Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to generate QR code' });
    }
  };

  const printInvoiceQR = async (invoiceData) => {
    try {
      const invoiceUrl = `${process.env.REACT_APP_RECEIPT_FRONT_END}/${invoiceData.unique_code}`;
      const qrDataUrl = await QRCode.toDataURL(invoiceUrl);
      const printWindow = window.open('', '_blank', 'width=600,height=600');
      if (printWindow) {
        const styles = `
          <style>
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body { font-family: 'Inter', sans-serif; padding: 30px; background: #f5f7fb; }
            .container { max-width: 400px; margin: 0 auto; background: white; border-radius: 20px; padding: 30px; text-align: center; }
            .qr-code { margin: 20px 0; }
            .qr-code img { max-width: 160px; }
            .info { text-align: left; background: #f8f9fa; padding: 15px; border-radius: 12px; margin-top: 15px; }
            .info p { margin: 5px 0; font-size: 13px; }
          </style>
        `;
        printWindow.document.write(`
          <html><head><title>Print QR</title>${styles}</head>
          <body>
            <div class="container">
              ${businessLogo ? `<img src="${process.env.REACT_APP_RECEIPT_FRONT_END}/${businessLogo}" style="max-width:70px" onerror="this.style.display='none'" />` : ''}
              <div class="qr-code"><img src="${qrDataUrl}" /></div>
              <div class="info">
                <p><strong>Invoice:</strong> ${escapeHtml(invoiceData.invoice_number)}</p>
                <p><strong>Customer:</strong> ${escapeHtml(invoiceData.customer_name)}</p>
              </div>
            </div>
            <script>
              window.onload = function() { 
                setTimeout(function() { window.print(); }, 500);
                setTimeout(function() { window.close(); }, 2000);
              }
            <\/script>
          </body></html>
        `);
        printWindow.document.close();
      }
    } catch (error) {
      console.error('QR generation error:', error);
      Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to generate QR' });
    }
  };

  const escapeHtml = (str) => {
    if (!str) return '';
    return String(str).replace(/[&<>]/g, function(m) {
      if (m === '&') return '&amp;';
      if (m === '<') return '&lt;';
      if (m === '>') return '&gt;';
      return m;
    }).replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, function(c) {
      return c;
    });
  };

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/");
    setTimeout(() => window.location.reload(), 100);
  };

  // ======================= SHORTCUTS GUIDE =======================
  const SHORTCUTS = {
    'Alt+1 / Alt+N': 'Create New Record',
    'Alt+2 / Alt+I': 'View Invoices',
    'Alt+3 / Alt+P': 'Promo Report',
    'Alt+4 / Alt+R': 'Referral History',
    'Alt+5 / Alt+L': 'Loyalty Checker',
    'Alt+S': 'Submit Form',
    'Ctrl+Shift+P': 'Print QR',
    'Ctrl+Shift+C': 'Clear Form',
    'F1': 'Show Shortcuts Guide',
    '+ / =': 'Add new item row (when focused on last row)',
    '- / _': 'Remove last empty row'
  };

  const showShortcutsGuidePopup = () => {
    const shortcutsHtml = Object.entries(SHORTCUTS).map(([key, desc]) => `
      <div class="shortcut-item">
        <kbd>${key}</kbd>
        <span>${desc}</span>
      </div>
    `).join('');
    
    Swal.fire({
      title: '<i class="fas fa-keyboard"></i> Keyboard Shortcuts',
      html: `<div class="shortcuts-guide">${shortcutsHtml}</div>`,
      confirmButtonText: 'Got it',
      confirmButtonColor: '#4361ee',
      customClass: {
        popup: 'shortcuts-popup'
      }
    });
  };

  // ======================= KEYBOARD SHORTCUTS =======================
// ======================= KEYBOARD SHORTCUTS =======================
useEffect(() => {
  const handleKeyDown = (e) => {
    // Add safety check for e.key
    if (!e || !e.key) return;
    
    const isAlt = e.altKey;
    const isCtrl = e.ctrlKey;
    const isShift = e.shiftKey;
    const key = e.key.toLowerCase();
    
    if (e.key === 'F1') {
      e.preventDefault();
      showShortcutsGuidePopup();
      return;
    }
    
    if (key === '+' || key === '=') {
      e.preventDefault();
      if (activeTab === Tabs.CREATE) {
        addDetailRow();
      }
      return;
    }
    
    if (key === '-' || key === '_') {
      e.preventDefault();
      if (activeTab === Tabs.CREATE) {
        removeLastEmptyRow();
      }
      return;
    }
    
    if (isAlt) {
      switch(key) {
        case '1':
        case 'n':
          e.preventDefault();
          handleTabChange(Tabs.CREATE);
          return;
        case '2':
        case 'i':
          e.preventDefault();
          handleTabChange(Tabs.INVOICES);
          return;
        case '3':
        case 'p':
          e.preventDefault();
          handleTabChange(Tabs.PROMO_REPORT);
          return;
        case '4':
        case 'r':
          e.preventDefault();
          handleTabChange(Tabs.REFERRAL_HISTORY);
          return;
        case '5':
        case 'l':
          e.preventDefault();
          handleTabChange(Tabs.LOYALTY);
          return;
        case 's':
          if (activeTab === Tabs.CREATE) {
            e.preventDefault();
            const form = document.getElementById('create-receipt-form');
            if (form) form.dispatchEvent(new Event('submit', { bubbles: true }));
          }
          return;
      }
    }
    
    if (isCtrl && isShift && key === 'p' && activeTab === Tabs.CREATE && showQRPopup) {
      e.preventDefault();
      printQR();
      return;
    }
    
    if (isCtrl && isShift && key === 'c' && activeTab === Tabs.CREATE) {
      e.preventDefault();
      resetCreateForm();
      Swal.fire({ icon: 'info', title: 'Form Cleared', text: 'All fields have been reset', timer: 1500, showConfirmButton: false });
      return;
    }
  };
  
  window.addEventListener('keydown', handleKeyDown);
  return () => window.removeEventListener('keydown', handleKeyDown);
}, [activeTab, showQRPopup, addDetailRow, removeLastEmptyRow, handleTabChange, printQR, resetCreateForm]);

  // FIXED: Setup global functions for QR with proper error handling
  useEffect(() => {
    // Global function for handling QR clicks from DataTable
    window.handleQRClick = (encodedData) => {
      try {
        const decodedData = decodeURIComponent(encodedData);
        const invoiceData = JSON.parse(decodedData);
        printInvoiceQR(invoiceData);
      } catch (error) {
        console.error('Error parsing invoice data:', error);
        Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to load invoice data for QR code' });
      }
    };
    
    window.generateInvoiceQR = generateInvoiceQR;
    window.printInvoiceQR = printInvoiceQR;
    
    return () => {
      delete window.handleQRClick;
      delete window.generateInvoiceQR;
      delete window.printInvoiceQR;
    };
  }, [businessLogo]);

  // FIXED: Fetch referral history with proper error handling
  const fetchReferralHistory = async () => {
    if (!referralSearchPhone || referralSearchPhone.trim() === '') {
      Swal.fire({ icon: 'warning', title: 'Warning', text: 'Please enter a phone number!' });
      return;
    }
    
    setReferralLoading(true);
    setReferralError(null);
    
    try {
      let formattedPhone = referralSearchPhone.replace(/\D/g, '');
      if (formattedPhone.startsWith('0')) formattedPhone = formattedPhone.substring(1);
      if (!formattedPhone.startsWith('+')) formattedPhone = '+92' + formattedPhone;
      
      const params = new URLSearchParams({
        business_id: businessId,
        phone_number: formattedPhone,
        branch_id: loggedInBranchId.current || ''
      });
      
      const response = await fetch(`${process.env.REACT_APP_RECEIPT_BACK_END_URL}/api/referral/history?${params}`, {
        headers: { 'Authorization': `Bearer ${sessionStorage.getItem('token')}` }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      
      // Safe data extraction with fallbacks
      let referrals = [];
      let analytics = {
        total_referrals: 0,
        successful_referrals: 0,
        promo_usage_count: 0
      };
      
      if (data && typeof data === 'object') {
        if (Array.isArray(data)) {
          referrals = data;
        } else if (Array.isArray(data.referrals)) {
          referrals = data.referrals;
        } else if (data.data && Array.isArray(data.data)) {
          referrals = data.data;
        }
        
        analytics = {
          total_referrals: referrals.length,
          successful_referrals: referrals.filter(r => r && (r.status === 'used' || r.is_used === 1)).length,
          promo_usage_count: referrals.filter(r => r && r.is_used === 1).length,
        };
      }
      
      setReferralHistory(referrals);
      setReferralAnalytics(analytics);
      
      if (referrals.length === 0) {
        Swal.fire({ icon: 'info', title: 'No Results', text: 'No referral history found for this number' });
      }
    } catch (error) {
      console.error('Error fetching history:', error);
      setReferralError(error.message);
      setReferralHistory([]);
      setReferralAnalytics({ total_referrals: 0, successful_referrals: 0, promo_usage_count: 0 });
      Swal.fire({ 
        icon: 'error', 
        title: 'Error', 
        text: 'Failed to fetch referral history. Please try again.' 
      });
    } finally {
      setReferralLoading(false);
    }
  };

  // Check loyalty summary
  const checkLoyaltySummary = async () => {
    if (!loyaltyState.searchTerm) {
      Swal.fire({ icon: 'warning', title: 'Warning', text: 'Please enter a phone number!' });
      return;
    }
    setCheckingLoyalty(true);
    try {
      let formattedPhone = loyaltyState.searchTerm.replace(/\D/g, '');
      if (formattedPhone.startsWith('0')) formattedPhone = formattedPhone.substring(1);
      if (!formattedPhone.startsWith('+')) formattedPhone = '+92' + formattedPhone;
      
      const params = new URLSearchParams({
        business_id: businessId,
        phone_number: formattedPhone
      });
      const response = await fetch(`${process.env.REACT_APP_RECEIPT_BACK_END_URL}/api/loyalty/available?${params}`, {
        headers: { 'Authorization': `Bearer ${sessionStorage.getItem('token')}` }
      });
      if (response.ok) {
        const data = await response.json();
        setLoyaltyState(prev => ({ ...prev, loyaltySummary: data }));
      } else {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Customer not found!' });
      }
    } catch (error) {
      console.error('Error checking loyalty:', error);
      Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to check loyalty points' });
    } finally {
      setCheckingLoyalty(false);
    }
  };

  // Clean up on unmount - destroy all DataTables
  useEffect(() => {
    return () => {
      if (invoicesDataTableRef.current) {
        try {
          invoicesDataTableRef.current.destroy(true);
          invoicesDataTableRef.current = null;
        } catch (e) {}
      }
      if (promoDataTableRef.current) {
        try {
          promoDataTableRef.current.destroy(true);
          promoDataTableRef.current = null;
        } catch (e) {}
      }
      // Clean up global functions
      delete window.handleQRClick;
      delete window.generateInvoiceQR;
      delete window.printInvoiceQR;
    };
  }, []);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  // ======================= RENDERERS =======================
  const renderCreateRecord = () => {
    return (
      <div className="create-record-tab">
        <div className="shortcuts-hint">
          <strong>{createRecordState.formData.invoice_number}</strong>
        </div>
        <form id="create-receipt-form" onSubmit={handleCreateRecordSubmit}>

          <div className="row g-3 mb-4">
            <div className="col-12 col-md-3">
              <div className="form-group-modern">
                <label><i className="fas fa-user"></i> Customer Name *</label>
                <input type="text" name="customer_name" className="form-control-modern" value={createRecordState.formData.customer_name} onChange={handleCreateRecordInputChange} placeholder="Enter customer name" />
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="form-group-modern">
                <label><i className="fas fa-phone"></i> Customer Number *</label>
                <input type="tel" name="customer_number" className="form-control-modern" placeholder="Enter customer number" value={createRecordState.formData.customer_number} onChange={handleCustomerNumberChange} />
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="form-group-modern">
                <label><i className="fas fa-calendar"></i> Date</label>
                <input type="datetime-local" className="form-control-modern" value={createRecordState.formData.date.slice(0, 16)} onChange={(e) => {
                  const dateTime = e.target.value;
                  setCreateRecordState(prev => ({ ...prev, formData: { ...prev.formData, date: dateTime.replace('T', ' ') + ':00' } }));
                }} />
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="form-group-modern">
                <label><i className="fas fa-user-tie"></i> Cashier</label>
                <input type="text" name="cashier" className="form-control-modern" value={createRecordState.formData.cashier || userData?.name || ''} onChange={handleCreateRecordInputChange} placeholder="Cashier name" />
              </div>
            </div>
          </div>

          <div className="card-modern mb-4">
            <div className="card-header-modern">
              <i className="fas fa-receipt"></i>
              <h5>Purchased Items</h5>
              <span className="item-count">{createRecordState.formData.details.length} items</span>
            </div>
            <div className="card-body-modern">
              <div className="invoice-items-scroll">
                <table className="items-table">
                  <thead>
                    <tr>
                      <th>Item Name</th>
                      <th>Quantity</th>
                      <th>Price</th>
                      <th>Total</th>
                      <th style={{ width: '50px' }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {createRecordState.formData.details.map((detail, index) => (
                      <tr key={index}>
                        <td><input type="text" className="item-input" value={detail.item_name} onChange={(e) => handleDetailRowChange(index, 'item_name', e.target.value)} placeholder="Item name" /></td>
                        <td><input type="number" className="qty-input" value={detail.quantity} onChange={(e) => handleDetailRowChange(index, 'quantity', parseFloat(e.target.value) || 0)} /></td>
                        <td><input type="number" className="price-input" value={detail.price} onChange={(e) => handleDetailRowChange(index, 'price', parseFloat(e.target.value) || 0)} /></td>
                        <td className="total-cell">{detail.total.toFixed(2)}</td>
                        <td><button type="button" className="remove-row-btn" onClick={() => removeDetailRow(index)}><i className="fas fa-trash-alt"></i></button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <button type="button" className="add-row-btn" onClick={addDetailRow}>
                <i className="fas fa-plus"></i> Add Item
              </button>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-12 col-md-5">
              <div className="card-modern">
                <div className="card-header-modern">
                  <i className="fas fa-tag"></i>
                  <h5>Discount & Loyalty</h5>
                </div>
                <div className="card-body-modern">
                  <div className="form-group-modern mb-3">
                    <label><i className="fas fa-ticket-alt"></i> Discount Code</label>
                    <input 
                      type="text" 
                      className="form-control-modern" 
                      placeholder="Enter discount code" 
                      value={discountCode} 
                      onChange={handleDiscountCodeChange}
                      disabled={!createRecordState.formData.customer_number}
                    />
                    {!createRecordState.formData.customer_number && (
                      <small className="text-muted">Enter customer number first to apply discount</small>
                    )}
                    {discountApplied && <span className="discount-badge"><i className="fas fa-check-circle"></i> {discountPercentage}% discount applied</span>}
                  </div>
                  <div className="loyalty-info-box">
                    <div className="loyalty-header">
                      <i className="fas fa-star"></i>
                      <span>Loyalty Points</span>
                    </div>
                    {checkingLoyalty && <div className="loyalty-loading"><i className="fas fa-spinner fa-spin"></i> Checking...</div>}
                    {availableLoyaltyPoints && (
                      <div className="loyalty-details">
                        <span className="points-available">Available: <strong>{availableLoyaltyPoints.available_points}</strong> pts</span>
                        <span className="points-total">Total Earned: {availableLoyaltyPoints.total_earned_points || 0} pts</span>
                      </div>
                    )}
                    {availableLoyaltyPoints && availableLoyaltyPoints.available_points > 0 && (
                      <div className="form-group-modern mt-2">
                        <label>Points to Use</label>
                        <input type="number" className="form-control-modern" placeholder="Enter points to use" value={createRecordState.formData.loyalty_points_used || ''} onChange={handleLoyaltyPointsChange} min="0" max={availableLoyaltyPoints.available_points} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-7">
              <div className="card-modern totals-card">
                <div className="card-header-modern">
                  <i className="fas fa-calculator"></i>
                  <h5>Bill Summary</h5>
                </div>
                <div className="card-body-modern">
                  <div className="totals-list">
                    <div className="total-row">
                      <span>Subtotal</span>
                      <span className="total-amount">{createRecordState.formData.subtotal_amount.toFixed(2)}</span>
                    </div>
                    <div className="total-row tax-row">
                      <span>Tax ({createRecordState.formData.tax_amount}%)</span>
                      <input type="number" className="tax-input" value={createRecordState.formData.tax_amount} onChange={handleTaxChange} step="0.01" />
                      <span className="tax-value">{((createRecordState.formData.subtotal_amount * createRecordState.formData.tax_amount) / 100).toFixed(2)}</span>
                    </div>
                    <div className="total-row discount-row">
                      <span>Discount</span>
                      <span className="discount-amount">-{createRecordState.formData.discount_amount.toFixed(2)}</span>
                    </div>
                    {createRecordState.formData.loyalty_points_used > 0 && (
                      <div className="total-row loyalty-row">
                        <span>Loyalty Used</span>
                        <span className="loyalty-amount">-{createRecordState.formData.loyalty_points_used.toFixed(2)}</span>
                      </div>
                    )}
                    <div className="total-row grand-total">
                      <span>Total After Tax</span>
                      <span className="grand-total-amount">{createRecordState.formData.total_after_tax.toFixed(2)}</span>
                    </div>
                    <div className="total-row">
                      <span>Paid Amount</span>
                      <input type="number" className="paid-input" value={createRecordState.formData.paid_amount} onChange={handlePaidAmountChange} step="0.01" />
                    </div>
                    <div className="total-row">
                      <span>Remaining</span>
                      <span className={createRecordState.formData.remaining_amount > 0 ? 'remaining-negative' : 'remaining-zero'}>{createRecordState.formData.remaining_amount.toFixed(2)}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="receipt-button-container">
            <button type="submit" className="submit-receipt-btn" disabled={createRecordState.isSubmitting}>
              {createRecordState.isSubmitting ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-receipt"></i>}
              {createRecordState.isSubmitting ? 'Creating...' : 'Generate Receipt'}
            </button>
          </div>
        </form>

        {showQRPopup && createRecordState.qrCodeUrl && (
          <div className="qr-popup-overlay" onClick={() => setShowQRPopup(false)}>
            <div className="qr-popup-content" onClick={(e) => e.stopPropagation()}>
              <div className="qr-popup-header">
                <h4><i className="fas fa-qrcode"></i> Digital Receipt QR</h4>
                <button className="qr-popup-close" onClick={() => setShowQRPopup(false)}>&times;</button>
              </div>
              <div className="qr-popup-body">
                <img src={createRecordState.qrCodeUrl} alt="QR Code" />
              </div>
              <div className="qr-popup-footer">
                <button className="btn-print-qr" onClick={() => { printQR(); setShowQRPopup(false); }}><i className="fas fa-print"></i> Print QR</button>
   
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderViewInvoices = () => {
    return (
      <div className="view-invoices-tab">
        <div className="filters-bar">
          <div className="filter-group">
            <i className="fas fa-calendar-alt"></i>
            <input type="date" className="filter-input" placeholder="From Date" value={invoicesState.filters.start_date} onChange={(e) => setInvoicesState(prev => ({ ...prev, filters: { ...prev.filters, start_date: e.target.value } }))} />
          </div>
          <div className="filter-group">
            <i className="fas fa-calendar-alt"></i>
            <input type="date" className="filter-input" placeholder="To Date" value={invoicesState.filters.end_date} onChange={(e) => setInvoicesState(prev => ({ ...prev, filters: { ...prev.filters, end_date: e.target.value } }))} />
          </div>
          <div className="filter-group search-group">
            <input type="text" className="filter-input" placeholder="Search invoices..." value={invoicesState.filters.search} onChange={(e) => setInvoicesState(prev => ({ ...prev, filters: { ...prev.filters, search: e.target.value } }))} onKeyPress={(e) => e.key === 'Enter' && invoicesDataTableRef.current && invoicesDataTableRef.current.ajax.reload()} />
          </div>
          <button className="apply-filters-btn" onClick={() => {
            if (invoicesDataTableRef.current) {
              invoicesDataTableRef.current.ajax.reload();
            }
          }}><i className="fas fa-filter"></i> Apply</button>
          <button className="reset-filters-btn" onClick={() => {
            setInvoicesState(prev => ({ ...prev, filters: { start_date: '', end_date: '', search: '' } }));
            setTimeout(() => {
              if (invoicesDataTableRef.current) {
                invoicesDataTableRef.current.ajax.reload();
              }
            }, 100);
          }}><i className="fas fa-undo-alt"></i> Reset</button>
        </div>
        
        <div className="invoices-table-container">
          <table ref={invoicesTableRef} className="data-table invoices-datatable" width="100%">
            <thead>
              <tr>
                <th>Invoice #</th>
                <th>Customer Name</th>
                <th>Customer Number</th>
                <th>Branch</th>
                <th>Total</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    );
  };

  const renderLoyaltyChecker = () => (
    <div className="loyalty-checker-tab">
      <div className="loyalty-search-card">
        <div className="card-icon-large">
          <i className="fas fa-star-of-life"></i>
        </div>
        <h3>Check Loyalty Points</h3>
        <p>Enter customer phone number to view available loyalty points</p>
        <div className="search-input-large">
          <i className="fas fa-phone"></i>
          <input type="tel" placeholder="Enter Phone Number Starts With 03" value={loyaltyState.searchTerm} onChange={(e) => setLoyaltyState(prev => ({ ...prev, searchTerm: e.target.value }))} onKeyPress={(e) => e.key === 'Enter' && checkLoyaltySummary()} />
          <button onClick={checkLoyaltySummary} disabled={checkingLoyalty}>
            {checkingLoyalty ? <i className="fas fa-spinner fa-spin"></i> : ''} Check
          </button>
        </div>
      </div>
      
      {loyaltyState.loyaltySummary && (
        <div className="loyalty-result-card">
          <div className="result-header">
            <i className="fas fa-user-check"></i>
            <h4>Loyalty Information</h4>
          </div>
          <div className="points-display">
            <div className="points-item">
              <span>Total Earned Points</span>
              <strong>{loyaltyState.loyaltySummary.total_earned_points || 0}</strong>
            </div>
            <div className="points-item">
              <span>Total Used Points</span>
              <strong>{loyaltyState.loyaltySummary.total_used_points || 0}</strong>
            </div>
            <div className="points-item highlight">
              <span>Available Points</span>
              <strong>{loyaltyState.loyaltySummary.available_points || 0}</strong>
            </div>
          </div>
          <div className="customer-details">
            <p><i className="fas fa-phone"></i> {loyaltyState.loyaltySummary.phone_number}</p>
          </div>
        </div>
      )}
    </div>
  );

const renderReferralHistory = () => (
  <div className="referral-history-tab">
    <div className="stats-cards">
      <div className="stat-card-mini purple">
        <i className="fas fa-users"></i>
        <div><span className="stat-value">{referralAnalytics.total_referrals}</span><span className="stat-label">Total Referrals</span></div>
      </div>
      <div className="stat-card-mini green">
        <i className="fas fa-check-circle"></i>
        <div><span className="stat-value">{referralAnalytics.successful_referrals}</span><span className="stat-label">Successful</span></div>
      </div>
      <div className="stat-card-mini blue">
        <i className="fas fa-ticket-alt"></i>
        <div><span className="stat-value">{referralAnalytics.promo_usage_count}</span><span className="stat-label">Promo Used</span></div>
      </div>
    </div>
    
    <div className="search-section">
      <div className="search-wrapper">
        <input 
          type="tel" 
          placeholder="Enter Phone Number" 
          value={referralSearchPhone} 
          onChange={(e) => {
            setReferralSearchPhone(e.target.value);
            setReferralError(null);
          }} 
          onKeyPress={(e) => e.key === 'Enter' && fetchReferralHistory()} 
        />
        <button onClick={fetchReferralHistory} disabled={referralLoading}>
          {referralLoading ? <i className="fas fa-spinner fa-spin"></i> : ''} Search
        </button>
      </div>
    </div>
    
    {referralError && (
      <div className="error-message" style={{textAlign: 'center', color: '#dc2626', padding: '10px', marginBottom: '15px'}}>
        <i className="fas fa-exclamation-triangle"></i> {referralError}
      </div>
    )}
    
    <div className="history-table-container">
      <table className="modern-data-table">
        <thead>
          <tr>
            <th>Branch</th>
            <th>Customer Name</th>
            <th>Phone</th>
            <th>Receiver</th>
            <th>Branch Used</th>
            <th>Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {referralHistory.length > 0 ? referralHistory.map((referral, idx) => (
            <tr key={idx}>
              <td>{referral?.referral_branch_name || '-'}</td>
              <td>{referral?.customer_name || '-'}</td>
              <td>{referral?.customer_number || '-'}</td>
              <td>{referral?.receiver_name || '-'}</td>
              <td>{referral?.used_branch_name || '-'}</td>
              <td>{referral?.used_at ? new Date(referral.used_at).toLocaleDateString() : (referral?.created_at ? new Date(referral.created_at).toLocaleDateString() : '-')}</td>
              <td>
                <span className={`status-badge ${referral?.is_used === 1 ? 'used' : 'pending'}`}>
                  {referral?.is_used === 1 ? 'Used' : 'Pending'}
                </span>
              </td>
            </tr>
          )) : (
            <tr><td colSpan="7" className="empty-state"><i className="fas fa-inbox"></i> No referral history found</td></tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);

  const renderPromoReport = () => (
    <div className="promo-report-tab">
      <div className="report-filters">
        <select className="filter-select" value={promoReportState.filters.status} onChange={(e) => {
          setPromoReportState(prev => ({ ...prev, filters: { ...prev.filters, status: e.target.value } }));
          setTimeout(() => {
            if (promoDataTableRef.current) {
              promoDataTableRef.current.ajax.reload();
            }
          }, 100);
        }}>
          <option value="all">All Status</option>
          <option value="used">Used</option>
          <option value="pending">Pending</option>
        </select>
        <input type="date" className="filter-date" placeholder="From Date" value={promoReportState.filters.fromDate} onChange={(e) => {
          setPromoReportState(prev => ({ ...prev, filters: { ...prev.filters, fromDate: e.target.value } }));
          setTimeout(() => {
            if (promoDataTableRef.current) {
              promoDataTableRef.current.ajax.reload();
            }
          }, 100);
        }} />
        <input type="date" className="filter-date" placeholder="To Date" value={promoReportState.filters.toDate} onChange={(e) => {
          setPromoReportState(prev => ({ ...prev, filters: { ...prev.filters, toDate: e.target.value } }));
          setTimeout(() => {
            if (promoDataTableRef.current) {
              promoDataTableRef.current.ajax.reload();
            }
          }, 100);
        }} />
        <button className="apply-report-filters" onClick={() => {
          if (promoDataTableRef.current) {
            promoDataTableRef.current.ajax.reload();
          }
        }}><i className="fas fa-filter"></i> Apply</button>
        <button className="reset-report-filters" onClick={() => {
          setPromoReportState(prev => ({ ...prev, filters: { search: '', status: 'all', fromDate: '', toDate: '' } }));
          setTimeout(() => {
            if (promoDataTableRef.current) {
              promoDataTableRef.current.ajax.reload();
            }
          }, 100);
        }}><i className="fas fa-undo-alt"></i> Reset</button>
      </div>
      
      <div className="promo-table-container">
        <table ref={promoTableRef} className="data-table promo-datatable" width="100%">
          <thead>
            <tr>
              <th>Promo Code</th>
              <th>Sender</th>
              <th>Receiver Name</th>
              <th>Points</th>
              <th>Branch Sent</th>
              <th>Branch Used</th>
              <th>Status</th>
              <th>Used At</th>
              <th>Created At</th>
              <th>Expired</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  );

  const renderDrawer = () => (
    <>
      <button className="drawer-toggle" onClick={toggleDrawer}>
        <i className="fas fa-bars"></i>
      </button>
      <div className={`drawer-overlay ${isDrawerOpen ? 'active' : ''}`} onClick={toggleDrawer}></div>
      <div className={`drawer-sidebar ${isDrawerOpen ? 'open' : ''}`}>
        <div className="drawer-header">
          <span><i className="fas fa-store"></i> Menu</span>
          <button className="drawer-close" onClick={toggleDrawer}>&times;</button>
        </div>
        <div className="drawer-tabs">
          <button className={`drawer-tab-btn ${activeTab === Tabs.CREATE ? 'active' : ''}`} onClick={() => handleTabChange(Tabs.CREATE)}>
            <i className="fas fa-plus-circle"></i> Create Record
          </button>
          <button className={`drawer-tab-btn ${activeTab === Tabs.INVOICES ? 'active' : ''}`} onClick={() => handleTabChange(Tabs.INVOICES)}>
            <i className="fas fa-file-invoice"></i> View Invoices
          </button>
          <button className={`drawer-tab-btn ${activeTab === Tabs.LOYALTY ? 'active' : ''}`} onClick={() => handleTabChange(Tabs.LOYALTY)}>
            <i className="fas fa-star"></i> Loyalty
          </button>
          <button className={`drawer-tab-btn ${activeTab === Tabs.REFERRAL_HISTORY ? 'active' : ''}`} onClick={() => handleTabChange(Tabs.REFERRAL_HISTORY)}>
            <i className="fas fa-chart-line"></i> Referral History
          </button>
          <button className={`drawer-tab-btn ${activeTab === Tabs.PROMO_REPORT ? 'active' : ''}`} onClick={() => handleTabChange(Tabs.PROMO_REPORT)}>
            <i className="fas fa-chart-bar"></i> Promo Report
          </button>
          <button className="drawer-tab-btn" onClick={handleLogout}>
            <i className="fas fa-sign-out-alt"></i> Logout
          </button>
        </div>
      </div>
    </>
  );

  const renderTabContent = () => {
  return (
    <>
      <div className="tab-panel" style={{ display: activeTab === Tabs.CREATE ? 'block' : 'none' }}>
        {renderCreateRecord()}
      </div>
      <div className="tab-panel" style={{ display: activeTab === Tabs.INVOICES ? 'block' : 'none' }}>
        {renderViewInvoices()}
      </div>
      <div className="tab-panel" style={{ display: activeTab === Tabs.LOYALTY ? 'block' : 'none' }}>
        {renderLoyaltyChecker()}
      </div>
      <div className="tab-panel" style={{ display: activeTab === Tabs.REFERRAL_HISTORY ? 'block' : 'none' }}>
        {renderReferralHistory()}
      </div>
      <div className="tab-panel" style={{ display: activeTab === Tabs.PROMO_REPORT ? 'block' : 'none' }}>
        {renderPromoReport()}
      </div>
    </>
  );
};

  if (loading) {
    return (
      <div className="preloader">
        <div className="loader">
          <div className="loader-spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="sales-page">
      <div className="sales-header">
        <button className="shortcuts-help-btn" onClick={showShortcutsGuidePopup} title="Keyboard Shortcuts (F1)">
          <i className="fas fa-keyboard"></i>
          <span className="shortcuts-text">Shortcuts</span>
        </button>
        <button className="logout-btn" onClick={handleLogout}>
          <i className="fas fa-sign-out-alt"></i>
          <span>Logout</span>
        </button>
        {businessLogo && (
          <img src={`${process.env.REACT_APP_RECEIPT_FRONT_END}/${businessLogo}`} alt="Logo" className="business-logo-header" />
        )}
      </div>

      <div className="sales-container">
        <div className="tabs-container">
          <button className={`tab ${activeTab === Tabs.CREATE ? 'active' : ''}`} onClick={() => handleTabChange(Tabs.CREATE)} title="Alt+N / Alt+1">
            <i className="fas fa-plus-circle"></i>
            <span>Create Record</span>
          </button>
          <button className={`tab ${activeTab === Tabs.INVOICES ? 'active' : ''}`} onClick={() => handleTabChange(Tabs.INVOICES)} title="Alt+I / Alt+2">
            <i className="fas fa-file-invoice"></i>
            <span>View Invoices</span>
          </button>
          <button className={`tab ${activeTab === Tabs.LOYALTY ? 'active' : ''}`} onClick={() => handleTabChange(Tabs.LOYALTY)} title="Alt+L / Alt+5">
            <i className="fas fa-star"></i>
            <span>Loyalty</span>
          </button>
          <button className={`tab ${activeTab === Tabs.REFERRAL_HISTORY ? 'active' : ''}`} onClick={() => handleTabChange(Tabs.REFERRAL_HISTORY)} title="Alt+R / Alt+4">
            <i className="fas fa-chart-line"></i>
            <span>Referral History</span>
          </button>
          <button className={`tab ${activeTab === Tabs.PROMO_REPORT ? 'active' : ''}`} onClick={() => handleTabChange(Tabs.PROMO_REPORT)} title="Alt+P / Alt+3">
            <i className="fas fa-chart-bar"></i>
            <span>Promo Report</span>
          </button>
        </div>
        
        <div className="referral-tab-content">
          {renderTabContent()}
        </div>
      </div>
      
      {renderDrawer()}
    </div>
  );
};

export default SalesPage;